<template>
  <CustomSidebar
    v-model:visible="locationVisible"
    position="bottom"
    :title="this.title"
    @hide="hide()"
    :dismissable="false"
  >
    <template #actions>
      <Button
        type="button"
        icon="pi pi-save"
        class="p-button p-button-success"
        @click="save()"
        label="Save"
      />
    </template>
    <span v-show="errMessage" class="p-error">Failed: {{ errMessage }}</span>
    <DataTable
      :value="model ? model.Helper_Locations : model"
      :paginator="true"
      :rows="5"
      :rowClass="rowClass"
      responsiveLayout="scroll"
    >
      <Column
        :exportable="false"
        :sortable="false"
        class="h-3rem"
        columnResizeMode="fit"
      >
        <template #header>
          <Button
            icon="pi pi-plus"
            class="p-button-info p-button-sm"
            @click="addDetail()"
          />
        </template>
        <template #body="slotProps">
          <Button
            icon="pi pi-minus"
            class="p-button-danger p-button-sm"
            @click="deleteDetail(slotProps.data)"
          />
        </template>
      </Column>
      <Column field="Location_Code" :header="$t('location')">
        <template #body="slotProps">
          <CustomSelect
            v-model="slotProps.data[slotProps.column.props.field]"
            :url="this.$API_URL + 'list/location_by_user'"
            :minLength="0"
            :filter="true"
            :params="{ userId: this.transporterCode }"
            class="p-inputtext-sm"
            style="display: flex"
            @change="editDetail(slotProps)"
          />
        </template>
      </Column>
    </DataTable>
  </CustomSidebar>
</template>
<script>
export default {
  data() {
    return {
      errMessage: null,
      blueprint: {
        Id: 0,
        Location_Code: "",
        Location_Name: "",
        User_Id: null,
        Vehicle_Id: null,
        mode: "",
        result: null,
      },
    };
  },
  props: {
    model: {
      type: Array,
      default: [],
    },
    title: {
      type: String,
      default: "",
    },
    locationVisible: {
      type: Boolean,
      default: false,
    },
    transporterCode: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      default: "",
    },
  },
  methods: {
    rowClass(data) {
      return data
        ? data.mode == this.$FORM_MODE_DELETE
          ? "hidden"
          : ""
        : null;
    },
    addDetail() {
      var newDetail = { ...this.blueprint };
      newDetail.mode = this.$FORM_MODE_CREATE;
      newDetail.User_Id = this.model.User_Id?this.model.User_Id:this.model.Employee_Number
      newDetail.Vehicle_Id = this.model.Id;
      this.model.Helper_Locations.push(newDetail);
    },
    editDetail(data) {
      if (data.mode == this.$FORM_MODE_UNCHANGED) {
        data.mode = this.$FORM_MODE_EDIT;
      }
    },
    deleteDetail(data) {
      if (data.mode == this.$FORM_MODE_CREATE) {
        var index = this.model.Helper_Locations.indexOf(data);
        this.model.Helper_Locations.splice(index, 1);
      } else {
        data.mode = this.$FORM_MODE_DELETE;
      }
    },
    save() {
      this.$emit("block-ui");
      this.$axios
        .post(this.url, this.model.Helper_Locations)
        .then((response) => {
          this.$emit("unblock-ui");
          if (response.data.message == this.$OK) {
            this.model.Helper_Locations = response.data.data.models
            this.model.Helper_Locations = this.model.Helper_Locations.filter(r=>r.mode!=this.$FORM_MODE_DELETE)
            this.model.Helper_Locations.map(r=>r.mode = this.$FORM_MODE_UNCHANGED)
            this.$emit("success",{locName:response.data.data.name,locList:this.model.Helper_Locations})
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: "Locations saved.",
              life: 50000,
            });
            this.hide();
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 50000,
            });
          }
        })
        .catch((err) => {
          this.$emit("unblock-ui");
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 50000,
          });
        });
    },
    hide() {
      this.errMessage = null;
      this.$emit("update:locationVisible", false);
    },
  },
  emits: ["hide", "block-ui", "unblock-ui","success"],
};
</script>
